<template>
   <footer id="site-footer" class="footer">
      <div class="footer__content">
         <p>Powered by and developed by:</p>
         <a href="//tiscreport.org" class="footer__logo">
            <div v-html="getLogoImg('logo-tiscreport', 'svg', true)" class="footer__logo-img"/>
            <span class="hidden">TISCreport</span>
         </a>
         <a href="//techfund.tiscreport.org" class="footer__logo">
            <div v-html="getLogoImg('logo-techfund', 'svg', true)" class="footer__logo-img"/>
            <span class="hidden">Techfund</span>
         </a>
      </div>
      <div class="footer__copyright">
         <p class="text-right"><em>©{{year}} Semantrica Ltd (09001464)</em></p>
      </div>
   </footer>
</template>

<script>
export default {
   data() {
      return { 
         year: new Date().getFullYear() 
      }
   },
}
</script>

<style lang='scss' scoped>
@import '~/assets/SCSS/Vana/footer.scss';
</style>
